import { useEffect, useState } from 'react';
import { isIOS } from '../lib/display.ts';
import { canPromptInstall, isInstalled, onInstallChange, promptInstall } from '../lib/install.ts';
import { IconShare } from './icons.tsx';

/**
 * Installing matters twice over: it is what makes the app open like an app, and on iOS it is the
 * precondition for push notifications existing at all. Chromium hands us a prompt to fire;
 * iOS never does, so there the only honest option is to show the steps.
 */
export function InstallCoach() {
  const [, rerender] = useState(0);
  useEffect(() => onInstallChange(() => rerender((n) => n + 1)), []);

  if (isInstalled()) return <p className="muted">Klarnus è installata su questo dispositivo.</p>;

  if (canPromptInstall()) {
    return <button className="btn block" onClick={() => void promptInstall()}>Installa Klarnus</button>;
  }

  if (isIOS()) return <IosInstallSteps />;

  return <p className="muted">Puoi installarla dal menu del browser: ⋮ → “Installa app”.</p>;
}

export function IosInstallSteps() {
  return (
    <ol className="muted" style={{ margin: 0, paddingLeft: 20, display: 'grid', gap: 6, fontSize: 15 }}>
      <li>Tocca <strong>Condividi</strong> <IconShare size={17} style={{ verticalAlign: '-3px' }} /> in basso nella barra di Safari.</li>
      <li>Scegli <strong>Aggiungi alla schermata Home</strong>.</li>
      <li>Apri Klarnus dalla sua icona: da lì arrivano anche le notifiche.</li>
    </ol>
  );
}
